















































import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService } from "../core/services/configService";
import { TextBlockType, SortTypeBlog } from "../core/constants";
import Vue from "vue";
import Component from "vue-class-component";
import store from "../core/store";
import PostCard from "../components/blog/PostCard.vue";
import SearchBar from "../components/listings/SearchBar.vue";
import ListingTopPanel from "../components/listings/ListingTopPanel.vue";
import HomeSection from "../components/home/HomeSection.vue";
import SectionPagination from "../components/pagination/SectionPagination.vue";

@Component({
  components: {
    PostCard,
    SearchBar,
    ListingTopPanel,
    HomeSection,
    SectionPagination,
  },
})
export default class BlogPage extends Vue {
  posts: any[] = [];
  error: string = "";
  sort: any[] = [];
  search: string = "";
  sortType: SortTypeBlog = SortTypeBlog.ByNew;
  firstRecord: number = 0;
  lastRecord: number = 0;
  pageSize: number = 30;
  totalCount: number = 0;

  get currentPage() {
    return Math.floor(this.firstRecord / this.pageSize) + 1;
  }

  get totalPages() {
    if (!this.totalCount) {
      return 1;
    }
    return Math.max(1, Math.ceil(this.totalCount / this.pageSize));
  }

  get resultsLabel() {
    return (
      this.$t("Showing") +
      " " +
      (this.firstRecord + 1) +
      "–" +
      this.lastRecord +
      " " +
      this.$t("of") +
      " " +
      this.totalCount +
      " " +
      this.$t("results")
    );
  }

  async mounted() {
    new SettingsService().setPageTitle(String(this.$t("Blog")));
    this.lastRecord = this.pageSize;
    this.sort = [
      { value: 1, label: this.$t("Sort By New") },
      { value: 2, label: this.$t("Sort By Old") },
    ];

    await this.loadData();
  }

  async loadData() {
    let filters: any = {};
    let postTypeFilter: any = {};
    let searchFilter: any = {};

    let sort: any = [];
    if (this.sortType !== null) {
      switch (Number(this.sortType)) {
        case SortTypeBlog.ByNew:
          sort = [{ colId: "Created", sort: "desc" }];
          break;
        case SortTypeBlog.ByOld:
          sort = [{ colId: "Created", sort: "asc" }];
          break;
      }
    }

    postTypeFilter["TextBlockType"] = {
      type: "equals",
      filter: TextBlockType.Posts,
      filterType: "number",
    };

    if (this.search !== null && this.search !== "") {
      searchFilter["Title"] = {
        condition1: {
          type: "contains",
          filter: this.search,
          filterType: "text",
        },
        condition2: {
          secondField: "Text",
          type: "contains",
          filter: this.search,
          filterType: "text",
        },
        condition3: {
          secondField: "SmalText",
          type: "contains",
          filter: this.search,
          filterType: "text",
        },
        operator: "OR",
      };

      filters = Object.assign(filters, searchFilter);
    }

    filters = Object.assign(filters, postTypeFilter);

    let gridStatus = JSON.stringify({ filters: filters, sort: sort });
    gridStatus = encodeURIComponent(gridStatus);

    const url = `${Settings.HostName}/api/cztextblocks/list-by-page?startRow=${this.firstRecord}&endRow=${this.lastRecord}&gridStatus=${gridStatus}`;
    const data = await new CrudService().httpGet(url);

    if (data == null || data === undefined || data.ok === false) {
      console.error("Crash getting posts");
      return;
    }

    this.posts = data.data;

    this.totalCount = data.totalCount;
    if (this.lastRecord >= this.totalCount) {
      this.lastRecord = this.totalCount;
    }
    window.scrollTo(0, 0);
  }

  getImage(name: string) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
  }

  setPage(page: number) {
    const safePage = Math.min(Math.max(page, 1), this.totalPages);
    this.firstRecord = (safePage - 1) * this.pageSize;
    this.lastRecord = this.firstRecord + this.pageSize;
  }

  goPrevPage() {
    if (this.currentPage <= 1) return;
    this.setPage(this.currentPage - 1);
    this.loadData();
  }

  goNextPage() {
    if (this.currentPage >= this.totalPages) return;
    this.setPage(this.currentPage + 1);
    this.loadData();
  }

  goToPage(page: number) {
    if (page === this.currentPage) return;
    this.setPage(page);
    this.loadData();
  }

  async selectSort() {
    this.setPage(1);
    await this.loadData();
  }

  async selectSearch() {
    if (this.search === "" || this.search.length > 3) {
      this.setPage(1);
      await this.loadData();
    }
  }
}
